import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import { setFinanceOrderStatus } from '@/api/financial-center'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { Loading } from 'element-ui'
@Component({})
export default class PaperOrderInfo extends Vue {
    orderId: number = undefined
    logShow = true
    infoData: any = {}
    status: string
    priceSum: number = null //订单金额合计
    approvalStatus: number = null
    type = ''
    reviewIdea = '' // 审批意见
    withdrawalDialogShow = false // 撤回审批弹框
    reviewDialogShow = false // 审批意见弹框
    editFileList: { file: string; cnFile: string; isRequired: string }[] = []
    editFiles = {
        projectAllId: null,
        souCoursePrice: null,
        discountPrice: null,
        price: null,
        haveIPQ: null,
        remark: null,
        priceOrRatio: null,
        dissertationType: null,
        contractNo: null,
    }
    isRequired = false
    editFileRequired = false
    disBtn = false
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    loading = false
    isNotReject = false

    created() {
        this.orderId = Number(this.$route.query.id)
        this.type = this.$route.query.type ? this.$route.query.type as string : ''
        this.status = this.$route.query.status as string
        this.types = this.$route.query.types as string
        this.getInfoData()
    }

    menuBtn = menuBtn
    formatDate = formatDate

    async getInfoData() {
        this.loading = true
        await getMessageReviewById(this.orderId,this.types).then((data:any)=>{
            this.infoData = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.priceSum = this.infoData.price  //订单金额合计
            this.editFileList = this.infoData.editFileList || []
            this.editFileList.forEach(item => {
                this.editFiles[item.file] = this.infoData[item.file]
            })
            if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
            this.stepNode.isFirstNode = this.infoData.isFirstNode
            this.stepNode.isSyncEkuaibao = this.infoData.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = this.infoData.isSyncEqianbao
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }
    discountPriceChange() {
        if (Number(this.editFiles.discountPrice) > Number(this.infoData.souCoursePrice)) {
            this.$message.error('优惠金额不能大于项目终端售价')
            return
        }
        this.priceSum = Number(this.infoData.souCoursePrice) - Number(this.editFiles.discountPrice) //订单金额合计
    }
    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.status !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }
    // 撤回审批
    async cancelApproval() {
        await setFinanceOrderStatus({ id: this.infoData.id, action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.withdrawalDialogShow = false
    }
    // 通过、驳回审批
    clickExamineApproveButton(status: number) {
        this.editFiles.price = this.priceSum
        this.editFiles.contractNo = '暂无合同编号'
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'approveId', this.orderId)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        this.approvedVisible = true
    }
    // 关闭审批意见弹框
    closeReviewDialog() {
        this.reviewIdea = ''
        this.reviewDialogShow = false
    }
    // 审批意见确认
    // confirmReviewDialog() {
    //     this.editFiles.price = this.priceSum
    //     this.editFiles.contractNo = '暂无合同编号'
    //     const newObj = this.editFiles
    //     for (const key in newObj) {
    //         if (!this.editFileList.some(item => item.file === key)) {
    //             delete newObj[key]
    //         }
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.approvalStatus === 1) {
    //         this.$message.error('请将编辑的信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.orderId,
    //         status: this.approvalStatus,
    //         opinion: this.reviewIdea,
    //         form: this.approvalStatus === 1 ? newObj : {},
    //         nodeType: this.nodeType,
    //         // isRevoke: this.approvalStatus === 1 ? this.isAgreeRevoke : ''
    //     }
    //     this.disBtn = true;
    //     const loading = Loading.service({
    //         text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
    //         this.reviewIdea = ''
    //         this.reviewDialogShow = false
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch(err=>{
    //         this.disBtn = false
    //     })
    // }


    // approvedConfirm() {
    //     this.editFiles.price = this.priceSum
    //     this.editFiles.contractNo = '暂无合同编号'
    //     const newObj = this.editFiles
    //     for (const key in newObj) {
    //         if (!this.editFileList.some(item => item.file === key)) {
    //             delete newObj[key]
    //         }
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.approvalStatus === 1) {
    //         this.$message.error('请将编辑的信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.orderId,
    //         status: this.approvalStatus,
    //         opinion: this.reviewIdea,
    //         form: this.approvalStatus === 1 ? newObj : {},
    //         isRevoke:this.isAgreeRevoke
    //     }
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批通过中，请稍后`
    //     })
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(`审批通过`)
    //         this.reviewDialogShow = false
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch(err => {
    //         this.disBtn = false
    //     })
    // }



    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.orderId)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.reviewIdea = data.reviewIdea
        // this.approvalVisible = false
        // this.confirmReviewDialog()
        this.approvalVisible = false
    }

    /*
 * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.reviewIdea = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()
        this.approvedVisible = false
    }
}
